'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useCallback, useEffect } from 'react';
import { PopoverContentInternal } from './popover-content-internal.component.js';
import { PopoverDialog } from './popover-dialog.component.js';
import { useSwanPopover } from './popover.context.js';
import { filterProps } from '../core/core.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
let u = {
    dialog: t.bool,
    fullBleed: t.bool
};
const PopoverContent = renderWithRef('PopoverContent', {}, (r, c)=>{
    var f;
    let { children: b, dialog: m = false, fullBleed: a, hideArrow: y, placement: d } = r, { overlayState: O, popoverPlacement: j } = useSwanPopover(), v = _object_spread_props(_object_spread({}, filterProps(r, Object.keys(u), processStyleProps(r))), {
        hideArrow: y,
        placement: null !== (f = null != d ? d : j) && void 0 !== f ? f : 'top',
        fullBleed: null != a ? a : void 0,
        role: m ? void 0 : 'tooltip',
        children: m ? jsx(PopoverDialog, {
            children: b
        }) : b
    }), _ = useCallback((e)=>{
        'Escape' === e.key && O.close();
    }, [
        O
    ]);
    return useEffect(()=>{
        if (!m) return O.isOpen ? document.addEventListener('keydown', _) : document.removeEventListener('keydown', _), ()=>{
            document.removeEventListener('keydown', _);
        };
    }, [
        m,
        O.isOpen,
        _
    ]), O.isOpen ? jsx(PopoverContentInternal, _object_spread_props(_object_spread({}, v), {
        ref: c
    })) : null;
});

export { PopoverContent };
